import Histogram from '../modules/chart/histogram'
import TemplateBK from '../modules/template_html/bk'

var data = {
    init: function () {
        let self = this
        self.makeHistogram1()
        self.makeHistogram2()
        self.makeBK1()
        self.makeBK2()
        self.makeBK3()
        self.makeBK4()
    },
    makeHistogram1: function () {
        let histogram1 = new Histogram({
            api: '//push2.eastmoney.com/api/qt/multi/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&rt6=fs%3Dm%3A90%2Bt%3A2%26po%3D1&rt6=fs%3Dm%3A90%2Bt%3A2%26po%3D0&np=1&pn=1&pz=3&fid=f62&fields=f12,f13,f14,f62',
            ele: 'hybkjlr',
            refresh_time:10,
            data: function (data) {
                let arr = data.data[0].diff.concat(data.data[1].diff.reverse())
                return arr
            }
        })
        histogram1.init()
    },
    makeHistogram2: function () {
        let histogram1 = new Histogram({
            api: '//push2.eastmoney.com/api/qt/multi/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&rt6=fs%3Dm%3A90%2Bt%3A3%26po%3D1&rt6=fs%3Dm%3A90%2Bt%3A3%26po%3D0&np=1&pn=1&pz=3&fid=f62&fields=f12,f13,f14,f62',
            ele: 'gnbkjlr',
            refresh_time:10,
            data: function (data) {
                let arr = data.data[0].diff.concat(data.data[1].diff.reverse())
                return arr
            }
        })
        histogram1.init()
    },
    makeBK1: function () {
        let self = this
        let bk = new TemplateBK({
            ele: 'jqrm',
            api: '//push2.eastmoney.com/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fs=m:90&np=1&pn=1&pz=8&po=1&fid=f127&invt=2&fltt=2&fields=f3,f4,f12,f13,f14,f127,f128,f136,f152',
            row: 2,
            col: 3,
            refresh_time:10,
            dataprocess: true,
            data: function (data) {
                return data.data.diff
            },
            dataprocessFun: function (_data) {
                let obj = {
                    html: `<div>
                        <a href='/quote/stock/${_data.f13}.${_data.f12}.html'>
                        <p>${_data.f14}</p>
                        <p class='${_data.f127 > 0 ? 'gp-asc' : (_data.f127 < 0 ? 'gp-des' : '')}'>${self.dataProcess(_data.f127,'%')}</p>
                        <p>
                            <span>${_data.f128 == null ? '-' : _data.f128}</span>
                            <span  class='${_data.f136 > 0 ? 'gp-asc' : (_data.f136 < 0 ? 'gp-des' : '')}'>${self.dataProcess(_data.f136,'%')}</span>
                        </p>
                        </a>
                    </div>`,
                }
                return obj
            }
        })
        bk.init()
    },
    makeBK2: function () {
        let bk = new TemplateBK({
            ele: 'hybk',
            api: '//push2.eastmoney.com/api/qt/multi/get?cb=?&rt6=fs%3Dm%3A90%2Bt%3A2%26po%3D1&rt6=fs%3Dm%3A90%2Bt%3A2%26po%3D0&ut=bd1d9ddb04089700cf9c27f6f7426281&np=1&pn=1&pz=3&fid=f3&invt=2&fltt=2&fields=f3,f4,f12,f13,f14,f128,f136,f152',
            row: 2,
            col: 3,
            refresh_time:10,
            data: function (data) {
                let res = data.data[0].diff.concat(data.data[1].diff)
                return res
            }
        })
        bk.init()
    },
    makeBK3: function () {
        let bk = new TemplateBK({
            ele: 'gnbk',
            api: '//push2.eastmoney.com/api/qt/multi/get?cb=?&rt6=fs%3Dm%3A90%2Bt%3A3%26po%3D1&rt6=fs%3Dm%3A90%2Bt%3A3%26po%3D0&ut=bd1d9ddb04089700cf9c27f6f7426281&np=1&pn=1&pz=3&fid=f3&invt=2&fltt=2&fields=f3,f4,f12,f13,f14,f128,f136,f152',
            row: 2,
            col: 3,
            refresh_time:10,
            data: function (data) {
                let res = data.data[0].diff.concat(data.data[1].diff)
                return res
            }
        })
        bk.init()
    },
    makeBK4: function () {
        let self = this
        let bk = new TemplateBK({
            ele: 'kszd',
            api: '//push2.eastmoney.com/api/qt/multi/get?cb=?&rt6=fs%3Dm%3A90%26po%3D1&rt6=fs%3Dm%3A90%26po%3D0&ut=bd1d9ddb04089700cf9c27f6f7426281&np=1&pn=1&pz=3&fid=f22&invt=2&fltt=2&fields=f3,f4,f12,f13,f14,f22,f128,f136,f152',
            row: 2,
            col: 3,
            refresh_time:10,
            dataprocess:true,
            data: function (data) {
                let res = data.data[0].diff.concat(data.data[1].diff)
                return res
            },
            dataprocessFun: function (_data) {
                let obj = {
                    html: `<div>
                    <a href='/quote/stock/${_data.f13}.${_data.f12}.html'>
                    <p>${_data.f14}</p>
                    <p class='${_data.f22 > 0 ? 'gp-asc' : (_data.f22 < 0 ? 'gp-des' : '')}'>${self.dataProcess(_data.f22,'%')}</p>
                    <p>
                        <span>${_data.f128 == null ? '-' : _data.f128}</span>
                        <span  class='${_data.f136 > 0 ? 'gp-asc' : (_data.f136 < 0 ? 'gp-des' : '')}'>${self.dataProcess(_data.f136,'%')}</span>
                    </p>
                    </a>
                    </div>`,
                }
                return obj
            }
        })
        bk.init()
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
          return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
          return f
        } else {
          var s = f.toString();
          var rs = s.indexOf('.');
          if (rs < 0) {
            rs = s.length;
            s += '.';
          }
          while (s.length <= rs + n) {
            s += '0';
          }
          return s;
        }
    },
    dataProcess(data,symbol){
        let self = this
        if(data == undefined || data == null || data == '-'){
            return '-'
        }else{
            return self.numberFix(data,2) + symbol
        }
    }
}

data.init()